import { chipStyle } from './mamvPalette';

/** Kanonische Kürzel — dieselben Daten in Liste, UV und App. */
export const CANONICAL_SHORT = {
  erteilt: '✓',
  erteilt_online: '✓',
  ea: 'EA',
  ua: 'UA',
  la: 'LA',
  verlegt: '→',
  offen: '?',
};

export const CANONICAL_TITLE = {
  erteilt: 'Unterricht erteilt',
  erteilt_online: 'Unterricht erteilt (Online)',
  ea: 'Teilnehmer:in entschuldigt abwesend',
  ua: 'Teilnehmer:in unentschuldigt abwesend',
  la: 'Lehrkraft abwesend',
  verlegt: 'Termin verlegt',
  offen: 'Status noch offen / nicht finalisiert',
};

const tone = (name) => {
  const s = chipStyle(name);
  return { bg: s.background, fg: s.color, border: s.borderColor };
};

export const STATUS_PALETTE = {
  erteilt: tone('success'),
  erteilt_online: tone('success'),
  ea: tone('warning'),
  ua: tone('danger'),
  la: tone('primary'),
  verlegt: tone('neutral'),
  offen: tone('neutral'),
};

const LEGACY_TO_CODE = {
  present: 'erteilt',
  absent_excused: 'ea',
  absent_unexcused: 'ua',
};

function fromCode(code, short, title) {
  if (!code) return null;
  return {
    code,
    short: short || CANONICAL_SHORT[code] || String(code).slice(0, 2).toUpperCase(),
    title: title || CANONICAL_TITLE[code] || code,
  };
}

/** Einheitlicher Status aus Kategorie, Verlegung oder Legacy-Feld. */
export function resolveAttendanceStatus(source = {}) {
  if (source.status_code) {
    return fromCode(source.status_code, source.status_short_label, source.status_label);
  }
  if (source.relocated_to_date || source.category_code === 'verlegt' || source.cancel_category_code === 'verlegt') {
    return fromCode('verlegt');
  }
  const explicit = source.category_code || source.cancel_category_code;
  if (explicit) return fromCode(explicit);
  if (source.erteilt || source.status === 'present') return fromCode('erteilt');
  if (source.status && LEGACY_TO_CODE[source.status]) return fromCode(LEGACY_TO_CODE[source.status]);
  if (source.makeup_open || source.cancelled) return fromCode('offen');
  const lessonDate = source.lesson_date || source.date;
  const today = source.today;
  if (lessonDate && today && String(lessonDate).slice(0, 10) < String(today).slice(0, 10)) {
    return fromCode('offen');
  }
  return null;
}

/** Erteilt, Online, EA, UA oder LA — nicht der leere Bearbeitungsstatus. */
export function attendanceCaptured(source = {}) {
  const code = source.category_code || source.cancel_category_code;
  if (code && code !== 'offen' && code !== 'verlegt') return true;
  if (source.erteilt) return true;
  const legacy = source.status || source.teacher_status;
  return legacy === 'present' || legacy === 'absent_excused' || legacy === 'absent_unexcused';
}

export function todayIsoLocal() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
